module.exports = __webpack_public_path__ + "img/webcams-and-microphones.1549a27b.svg";